<template>
    <div class="material-view view">
        <instructions titleKey="worktopMaterial" property="materialHelpContent" />

        <backpanel-drawing />

        <div class="wrapper">
            <div class="section-content">
                <h2 class="h2" v-html="ui.t('worktopMaterialChoose')"></h2>

                <option-list v-model="materialCode"
                    :optionList="ui.backpanelMaterial"
                    :withImages="true"
                    classes="big"
                    :enableZoom="true"
                    imageScaling="full"
                    :linkText="ui.t('worktopMaterialPreviewLinkText')"
                    :itemClasses="[ 'col-2-4' ]" />
            </div>
        </div>

        <div class="navigation">
            <div class="wrapper">
                <router-link to="/backpanel" v-html="ui.t('previous')" />
                <router-link to="/summary" @click.native="moveNext" :class="{ next: true, disabled: !ui.backpanelMaterialSelectionsComplete }">
                    <span class="input-tip" v-if="moveNextPrevented" v-html="ui.t('selectionsIncomplete')"></span>
                    <span v-html="ui.t('next')"></span>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script async setup lang="ts">
import { computed, ref } from 'vue';
import { useState, useUI } from '../store';

const moveNextPrevented = ref(false);
let moveNextTimer: number | null = null;

const { state } = useState();
const { ui } = useUI();

function moveNext() {
    moveNextPrevented.value = true;

    moveNextTimer = setTimeout(() => moveNextPrevented.value = false, 3000);
}

const materialCode = computed({
    get () {
        if (!state.material && !state.graphics)
            return null;

        if (state.graphics == "00" && state.material == "S")
            return "S";

        return state.material == "K" ? "K" : state.graphics || "S";
    },
    set (value: string) {
        //Material is S, if anything else but deko is selected
        state.material = value == "K" ? "K" : "S";

        //Set graphics if material is anything but deko
        state.graphics = value != "K" && value != "S" ? value : null;
    }
});

</script>
